export default __webpack_public_path__ + "static/media/36I-114289_-21016_0.4fcd1112.jpg";